import { render, staticRenderFns } from "./PartiesChart.vue?vue&type=template&id=df4f4196&scoped=true"
import script from "./PartiesChart.vue?vue&type=script&lang=js"
export * from "./PartiesChart.vue?vue&type=script&lang=js"
import style0 from "./PartiesChart.vue?vue&type=style&index=0&id=df4f4196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4f4196",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
